import React from "react";
import styled from "@mui/material/styles/styled";
import { DVGraphArea, GraphTooltipZIndex } from "../dvGraphArea";
import { featureToLines, hashQF } from "fe-common/logic";
import { PairGraphFragment, QualifiedFeature } from "fe-common/graphql";
import { TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import Autocomplete from "@mui/lab/Autocomplete";
import { GraphDetailSelection } from "../../util/graphDetialsSelectionHook";
import { GraphAreaActions } from "fe-web-components/graphview";
import { QualifiedFeatureFragment } from "fe-common/graphql";

//region [[ Styles ]]
const GraphContainer = styled(Paper)({
  boxShadow: "none",
  marginLeft: "5px",
  zIndex: GraphTooltipZIndex - 1,
  width: "100%",
  borderTopRightRadius: "20px",
  borderBottomRightRadius: "20px",
  display: "flex",
  position: "relative", // So absolute children will get its relative dimensions
  flexDirection: "column",
  background: "white",
  overflowY: "hidden",
});

const FindingDropDown = styled(Autocomplete)(({ theme }) => ({
  position: "absolute",
  zIndex: GraphTooltipZIndex - 2,
  margin: theme.spacing(2),
  left: theme.spacing(2),
  opacity: 1,
  top: "15px",
  width: "150px",
}));
//endregion [[ Styles ]]
//region [[ Props ]]
interface GraphProps {
  loading: boolean;
  graphData: { graph: PairGraphFragment };
  graphSelection: GraphDetailSelection;
  graphActions: React.MutableRefObject<GraphAreaActions>;
  supportingFinding: QualifiedFeatureFragment[];
  onSelectFeature: (qf: QualifiedFeature) => void;
  isMiniView?: boolean;
}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
const Graph = ({
  loading,
  graphData,
  graphSelection,
  graphActions,
  supportingFinding,
  onSelectFeature,
  isMiniView,
}: GraphProps) => {
  return (
    <GraphContainer>
      <DVGraphArea
        graph={graphData?.graph}
        loading={loading}
        selection={graphSelection}
        hideSummary={true}
        refGraphActions={graphActions}
        hideResetButton={isMiniView}
        defaultSelectedNodeId={
          isMiniView && supportingFinding[0]
            ? hashQF(supportingFinding[0])
            : null
        }
      >
        {isMiniView && supportingFinding && !!supportingFinding.length && (
          <FindingDropDown
            onChange={(e, val) => onSelectFeature(val as QualifiedFeature)}
            options={supportingFinding}
            getOptionLabel={(f) => featureToLines(f as QualifiedFeature)[0]}
            renderInput={(p) => <TextField disabled={true} {...p} />}
            disableClearable={true}
            defaultValue={supportingFinding[0]}
            blurOnSelect
          />
        )}
      </DVGraphArea>
    </GraphContainer>
  );
};

export default Graph;
